import { useCallback, useContext } from "react";
import { AuthContext, fp } from "../App";
import Constants from "../utils/Constants";
import { useFetch } from "../hooks/useFetch";

const apiBaseUrl = Constants.SERVER_URL;

const useCollaborator = () => {
  const { authState } = useContext(AuthContext);

  const { send } = useFetch();

  const findAll = useCallback(
    async (query) => {
      const config = {
        method: "get",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
      };

      return await send(apiBaseUrl + "/wapi/collaborators?companyId=" + query.companyId, config);
    },
    [authState.token, send]
  );

  // const invite = useCallback(
  //   async (params) => {
  //     const config = {
  //       method: "post",
  //       headers: {
  //         Authorization: "Bearer " + authState.token,
  //         "Content-Type": "application/json",
  //         FpId: (await fp).visitorId,
  //       },
  //       body: JSON.stringify(params),
  //     };

  //     return await send(apiBaseUrl + "/wapi/collaborators/invite", config);
  //   },
  //   [authState.token, send]
  // );

  const attendInvitation = useCallback(
    async (id, params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(apiBaseUrl + "/wapi/collaborators/" + id + "/attendInvitation", config);
    },
    [authState.token, send]
  );

  const removeCollaborator = useCallback(
    async (id, params) => {
      const config = {
        method: "post",
        headers: {
          Authorization: "Bearer " + authState.token,
          "Content-Type": "application/json",
          FpId: (await fp).visitorId,
        },
        body: JSON.stringify(params),
      };

      return await send(apiBaseUrl + "/wapi/collaborators/" + id + "/removeCollaborator", config);
    },
    [authState.token, send]
  );

  return {
    findAll,
    // invite,
    attendInvitation,
    removeCollaborator,
  };
};

export { useCollaborator };
